import React, { FC } from 'react';
import WebView from '@components/1-atoms/WebView';

type Props = {
    uri: string;
};

const _ : FC<Props> = ({ uri }) => {
    return <WebView fullpage source={{ uri }} />;
};

export default _;